import { render, staticRenderFns } from "./SocialFeedComment.vue?vue&type=template&id=d9d81244&"
import script from "./SocialFeedComment.vue?vue&type=script&lang=js&"
export * from "./SocialFeedComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports